module.exports = __webpack_public_path__ + "static/media/ncj_bangle_0004.d6693e22.jpg";